import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
const optionOne = ['Improvisando cada semana', 'Sin saber si está correcto', 'Alumnas que se van', 'Estrés y agotamiento', 'Inseguridad al cobrar'];
const optionTwo = ['240 fichas de ejercicios, preparaciones y variantes', 'Sistema claro y profesional', 'Alumnas que vuelven cada semana', 'Clases estructuradas para consultar', 'Confianza para cobrar más'];
export function FinalCTA() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-60" data-mp="33vxu26deunpa">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-61" data-mp="33x8v3yfh1hcp">
        <h2 className="font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-62" data-mp="38uiti3ku93co">
          🔥 La decisión es hoy
        </h2>
        <p className="mt-3 text-base text-ink/80 sm:text-lg" data-id="element-63" data-mp="172mciefwj1ai">Tienes dos opciones:</p>

        <div className="mt-8 grid gap-4 text-left sm:grid-cols-2" data-id="element-64" data-mp="1709trz2bkmwe">
          <div className="rounded-2xl border border-primary/10 bg-paper p-6" data-id="element-65" data-mp="q72f945mi14a">
            <p className="font-heading text-sm font-semibold uppercase tracking-wide text-ink/60" data-id="element-66" data-mp="l8hen3mglffb">
              Opción 1: Seguir como estás
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-67" data-mp="uzbzc3k246yn">
              {optionOne.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/80" data-id="element-68" data-mp="v1pueceqlj67">
                  <XIcon size={16} className="mt-0.5 flex-shrink-0 text-danger" data-id="element-69" data-mp="2ao9duod4ter" />
                  <span data-id="element-70" data-mp="2crapauyu8ys">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-accent/30 bg-white p-6 shadow-card-medium" data-id="element-71" data-mp="g8cwza9teeni">
            <p className="font-heading text-sm font-semibold uppercase tracking-wide text-accent" data-id="element-72" data-mp="bdgz3thwcx2h">
              Opción 2: Entrar con todo resuelto
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-73" data-mp="1mpq9booy8z51">
              {optionTwo.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink" data-id="element-74" data-mp="kc25jak7wflb">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-75" data-mp="pb56ojx2u1o0" />
                  <span data-id="element-76" data-mp="tdjtff3v9lkk">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-8 text-sm font-semibold text-danger sm:text-base" data-id="element-77" data-mp="ybldo3d13qxm">
          El precio sube en 24 horas. Después de eso, nunca bajará.
        </p>

        <m.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mt-6 flex flex-col items-center" data-id="element-78" data-mp="5nxtgpfo72bi">
          <PrimaryButton href={CHECKOUT_URL} data-id="element-79" data-mp="fesfbsp07zwf">Quiero la Enciclopedia Completa Ahora</PrimaryButton>
          <p className="mt-3 text-xs text-ink/60" data-id="element-80" data-mp="3e393letmkj6x">
            Descarga inmediata · Pago único · Acceso de por vida · Garantía 7 días
          </p>
          <p className="mt-1 text-xs text-ink/50" data-id="element-81" data-mp="3bjktjx47auv4">💱 El pago se procesará en la moneda de tu país</p>
        </m.div>
      </div>
    </section>;
}